<div class="jobcard-label" *ngIf="label" [ngStyle]="{color: labelColor ? labelColor : '', 'opacity': isDisabled ? '0.5' : '1'}">{{ label }}</div>
<div class="p-inputgroup" [ngStyle]="{'opacity': isDisabled ? '0.5' : '1'}">
  <span *ngIf="icon" class="input-icon">
    <daz-icon [color]="iconColor" [name]="icon" [size]="'20px'"></daz-icon>
  </span>

  <input #inputRef (input)="handleInputChange($event)" [ngClass]="{'hub-calendar-icon' : icon, 'invalid': required && !value, 'rounded': rounded  }"
    [placeholder]="placeholder" [(ngModel)]="value" [disabled]="isDisabled" autofocus="{{autofocus}}" class="hub-input"
    pInputText type="{{type}}" maxlength="{{maxLength}}">

  <span *ngIf="allowClear" class="clear-icon">
    <daz-icon [color]="'#6D6D6D'" [name]="'cross'" [size]="'20px'" (click)="clearInput()"></daz-icon>
  </span>
</div>
<div class="error-message" *ngIf="required && !value">{{ errorLabel }}</div>
